module.exports = __webpack_public_path__ + "static/home/img/vega.34291245.png";